export default __webpack_public_path__ + "42bf33a2cabd5a7695c3fe7ffcd15eae.bin";